export default __webpack_public_path__ + "static/media/mmo_rpg_map_image.c589aa08.png";